import { render } from "./AppList.vue?vue&type=template&id=21750858&scoped=true&ts=true"
import script from "./AppList.vue?vue&type=script&lang=ts"
export * from "./AppList.vue?vue&type=script&lang=ts"

import "./AppList.vue?vue&type=style&index=0&id=21750858&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/range-compose-campaign-ui_master/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21750858"]])

export default __exports__